import { ActionTypesFactory } from "../../common/redux/actions/ActionTypesFactory";

const profilesActionTypes = ActionTypesFactory.readActionTypes(
  "PROFILES"
);

export default profilesActionTypes;
